module.exports = __webpack_public_path__ + "images/application/i-github-9da6685e.svg";